import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { decodeTokenJsonUser } from '../../shared/helpers/jwtDecoder'
import { distinct } from '../../shared/helpers/distinctArray'
import { Card, CardContent, TextField, Grid, Typography, InputAdornment, FormControlLabel, Checkbox, IconButton, Icon, Tooltip, List, ListItem, ListItemText, ListItemSecondaryAction, Button, Fab, Divider, CircularProgress } from '@material-ui/core'
import { getSelectOptions } from '../../shared/helpers/selectHelper'
import { showWarning, showSuccess } from '../../redux/actions/snackbarActions';
import demandsService from '../../api/demandsService';
import ZipCodeField from '../../shared/components/ZipCodeField';
import PhoneNumberField from '../../shared/components/PhoneNumberField';

class CreateGoldenDemand extends Component {
    constructor(props) {
        super(props);

        this.state = {
            city: '',
            stateCode: '',
            category: '',
            subcategory: '',
            description: '',
            isFullTime: false,
            requirement: '',
            price: '',
            zipCode: '',
            allRequirements: [],
            customerName: '',
            customerContact: '',
            isExclusive: false,
            isLoading: false
        }

        this.setGenericState = this.setGenericState.bind(this);
        this.onChangeText = this.onChangeText.bind(this);
        this.onCheckedChange = this.onCheckedChange.bind(this);
        this.addRequirement = this.addRequirement.bind(this);
        this.removeRequirement = this.removeRequirement.bind(this);
        this.cleanForm = this.cleanForm.bind(this);
        this.publishDemand = this.publishDemand.bind(this);
    }

    setGenericState = (propertyName, value) => {
        this.setState({
            [propertyName]: value
        });
    }

    onChangeText = (evt) => {
        const { name, value } = evt.target;
        this.setGenericState(name, value);
    }

    onCheckedChange = (evt) => {
        const { name } = evt.target;
        this.setGenericState(name, !this.state[name])
    }

    addRequirement() {
        const { allRequirements, requirement } = this.state;

        if (allRequirements.includes(requirement)) {
            this.props.showWarning("This requirement exists in the list.");
            return;
        }

        if (requirement.length > 0) {
            this.setState({
                allRequirements: [...allRequirements, requirement],
                requirement: ''
            });
        }
    }

    removeRequirement(requirement) {
        const { allRequirements } = this.state;
        this.setState({
            allRequirements: allRequirements.filter((req) => req.toUpperCase() !== requirement.toUpperCase())
        });
    }

    publishDemand() {
        const { idCompany, showSuccess } = this.props;
        const { city, stateCode, category, subcategory, description, isFullTime, price, zipCode, customerContact, customerName,
            allRequirements, isExclusive } = this.state;

        this.setState({
            isLoading: true
        });

        demandsService.createGoldenDemand(idCompany, category, subcategory, city, stateCode,
            description, price, isFullTime, allRequirements, zipCode, customerContact, customerName, isExclusive)
            .then(() => {
                showSuccess('Your Golden Demand has been published successfully.');
                this.cleanForm();
                this.setState({
                    isLoading: false
                });
            })
            .catch(() => {
                this.setState({
                    isLoading: false
                });
            });
    }

    cleanForm() {
        const cleanedState = {};
        for (let prop of Object.keys(this.state)) {
            if (Array.isArray(this.state[prop])) {
                cleanedState[prop] = [];
            } else {
                cleanedState[prop] = "";
            }
        }

        this.setState(cleanedState);
    }

    render() {
        const { cities, states, categories } = this.props;
        const { city, stateCode, category, subcategory, description, isFullTime, price, requirement, zipCode, allRequirements,
            customerContact, customerName, isLoading, isExclusive } = this.state;

        const showSubcategory = this.state.category !== '';

        const citiesFiltered = this.state.stateCode !== '' ?
            distinct(cities.filter((city) => city.stateCode === this.state.stateCode), "value")
            :
            [{ value: '', display: 'First, choose a State.' }];

        const subcategoriesFiltered = showSubcategory ?
            categories.filter((cat) => cat.name === category)[0].subcategories.map((subcat) => ({ value: subcat.description, display: subcat.description }))
            :
            [{ value: '', display: 'Select a Category.' }];

        return (
            <div>
                <Link to="/" style={{ textDecoration: 'none' }}>
                    <Button variant="text">
                        <Icon style={{ marginRight: 10 }}>arrow_backward</Icon> Go back
                    </Button>
                </Link>
                <Card>
                    <CardContent>
                        <Typography variant="h5" style={{ paddingLeft: 5 }}>Make a Golden Demand</Typography>
                        <Grid container item>
                            <SectionHeading>What is the job's category?</SectionHeading>
                            <Grid item xs={12} sm={6} style={{ paddingLeft: 5, paddingRight: 5 }}>
                                <TextField
                                    select
                                    margin="normal"
                                    name="category"
                                    variant="outlined"
                                    label="Category"
                                    type="text"
                                    onChange={this.onChangeText}
                                    value={category}
                                    fullWidth
                                >
                                    {getSelectOptions(categories.map((cat) => ({ value: cat.name, display: cat.name })))}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={6} style={{ paddingLeft: 5, paddingRight: 5 }}>
                                <TextField
                                    select
                                    margin="normal"
                                    name="subcategory"
                                    variant="outlined"
                                    label="Subcategory"
                                    type="text"
                                    onChange={this.onChangeText}
                                    value={subcategory}
                                    fullWidth
                                >
                                    {getSelectOptions(subcategoriesFiltered)}
                                </TextField>
                            </Grid>
                            <SectionHeading>What it is about?</SectionHeading>
                            <Grid item xs={12} sm={12} style={{ paddingLeft: 5, paddingRight: 5 }}>
                                <TextField
                                    margin="normal"
                                    name="description"
                                    variant="outlined"
                                    label="Description"
                                    type="text"
                                    multiline
                                    rows={3}
                                    onChange={this.onChangeText}
                                    value={description}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} style={{ paddingLeft: 5, paddingRight: 5 }}>
                                <TextField
                                    margin="normal"
                                    name="customerName"
                                    variant="outlined"
                                    label="Customer's name"
                                    type="text"
                                    onChange={this.onChangeText}
                                    value={customerName}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} style={{ paddingLeft: 5, paddingRight: 5 }}>
                                <TextField
                                    margin="normal"
                                    name="customerContact"
                                    variant="outlined"
                                    label="Customer's contact"
                                    type="text"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{ inputComponent: PhoneNumberField }}
                                    onChange={this.onChangeText}
                                    value={customerContact}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} style={{ paddingLeft: 5, paddingRight: 5 }}>
                                <TextField
                                    margin="normal"
                                    name="price"
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">JCs</InputAdornment>,
                                    }}
                                    variant="outlined"
                                    label="Jobcoins' Amount"
                                    type="number"
                                    onChange={this.onChangeText}
                                    value={price}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} style={{ paddingLeft: 5, paddingRight: 5, display: 'flex', flexDirection: 'column' }}>
                                <FormControlLabel
                                    style={{ marginTop: 5 }}
                                    control={
                                        <Checkbox name="isFullTime" checked={isFullTime} onChange={this.onCheckedChange} />
                                    }
                                    label="Is a full time work?"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox name="isExclusive" checked={isExclusive} onChange={this.onCheckedChange} />
                                    }
                                    label="Is a InstaJob exclusive demand?"
                                />
                            </Grid>
                            <SectionHeading>Where it is located?</SectionHeading>
                            <Grid item xs={12} sm={6} style={{ paddingLeft: 5, paddingRight: 5 }}>
                                <TextField
                                    select
                                    margin="normal"
                                    name="stateCode"
                                    variant="outlined"
                                    label="State"
                                    type="text"
                                    onChange={this.onChangeText}
                                    value={stateCode}
                                    fullWidth
                                >
                                    {getSelectOptions(states)}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={6} style={{ paddingLeft: 5, paddingRight: 5 }}>
                                <TextField
                                    select
                                    margin="normal"
                                    name="city"
                                    variant="outlined"
                                    label="City"
                                    type="text"
                                    onChange={this.onChangeText}
                                    value={city}
                                    fullWidth
                                >
                                    {getSelectOptions(citiesFiltered)}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={6} style={{ paddingLeft: 5, paddingRight: 5 }}>
                                <TextField
                                    margin="normal"
                                    name="zipCode"
                                    variant="outlined"
                                    label="Zip Code"
                                    InputLabelProps={{ shrink: true }}
                                    type="text"
                                    InputProps={{ inputComponent: ZipCodeField }}
                                    onChange={this.onChangeText}
                                    value={zipCode}
                                    fullWidth
                                />
                            </Grid>
                            <SectionHeading>What are the requirements?</SectionHeading>
                            <Grid item xs={12}>
                                <TextField
                                    margin="normal"
                                    name="requirement"
                                    variant="outlined"
                                    label="Requirement"
                                    type="text"
                                    onChange={this.onChangeText}
                                    value={requirement}
                                    fullWidth
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Tooltip title="Add a new requirement" placement="top">
                                                    <IconButton
                                                        aria-label="Add a new requirement"
                                                        onClick={this.addRequirement}>
                                                        <Icon>add</Icon>
                                                    </IconButton>
                                                </Tooltip>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <List>
                                    {
                                        allRequirements.map((req, i) => (
                                            <ListItem key={i}>
                                                <ListItemText primary={req} />
                                                <ListItemSecondaryAction>
                                                    <IconButton onClick={() => {
                                                        this.removeRequirement(req);
                                                    }}>
                                                        <Icon>close</Icon>
                                                    </IconButton>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                        ))
                                    }
                                </List>
                            </Grid>
                            <Grid item xs={12}>
                                <Fab variant="extended" color="secondary" style={{ width: '100%' }} onClick={this.publishDemand} disabled={isLoading}>
                                    <Icon style={{ marginRight: 15 }}>send</Icon> Publish {isLoading && <CircularProgress size={24} color="inherit" style={{ marginLeft: 15 }} />}
                                </Fab>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </div>
        )
    }
}

const SectionHeading = ({ children }) => {
    return (
        <Grid item xs={12} style={{ paddingLeft: 5, paddingRight: 5, marginTop: 10 }}>
            <Typography variant="body1">{children}</Typography>
            <Divider />
        </Grid>
    );
}

const mapStateToProps = ({ categoryState, locationState, authState }) => ({
    idCompany: decodeTokenJsonUser(authState.loggedUser).company_identifier,
    categories: categoryState.categories,
    cities: locationState.localizations.map((city) => ({ value: city.cityName, display: city.cityName, stateCode: city.state.stateCode })),
    states: distinct(locationState.localizations.map((city) => ({ value: city.state.stateCode, display: city.state.state })), "value")
        .sort((a, b) => {
            if (a.display < b.display)
                return -1;
            if (a.display > b.display)
                return 1;
            return 0;
        })
});

const mapDispatchToProps = dispatch => (
    bindActionCreators({ showWarning, showSuccess }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(CreateGoldenDemand);